module.exports = __webpack_public_path__ + "static/media/ic_sunshine.7d746a29.png";